module.exports = __webpack_public_path__ + "static/media/Logo_cfe.c244bab3.png";